import { supabase } from '../../../api';

import { Grid, Typography, Box } from '@mui/material';

import Section from '../Article/Section';
import SubscribeSection from '../SubscribeSection/SubscribeSection';
import SuggestedArticles from '../SuggestedArticles/SuggestedArticles';

import { useParams, useNavigate } from 'react-router-dom';
import { useEffect, useState } from 'react';

import slugify from 'slugify';
import './style.css';

const ArticleLinks = (props) => {
  let [article, setArticle] = useState();

  let { id, slug } = useParams();
  let navigate = useNavigate();

  useEffect(() => {
    getArticle();
    // eslint-disable-next-line
  }, []);

  const getArticle = async () => {
    const { data: post, error } = await supabase.from('posts').select('*').eq('id', id).single();
    if (error) console.log(error);
    else {
      const createSlug = slugify(post.data.header, {
        lower: true,
        strict: true,
        locale: 'en',
      });
      if (slug !== post.data.header) navigate(`/stories/${id}/${createSlug}`, { replace: true });
      setArticle(post);
    }
  };

  if (article === undefined) {
    return (
      <Typography
        sx={{
          p: '20px',
          m: '20px',
        }}>
        In the time to load this article, Jeff Bezos made around $1,000. Inspired yet?
      </Typography>
    );
  }

  return (
    <Grid container justifyContent='center' alignItems='center' spacing={1}>
      <Box
        className='thumbnail-image'
        component='img'
        position='absolute'
        width='100vw'
        height='80vh'
        borderRadius='10px'
        filter='brightness(50%)'
        top='0px'
        margin='auto'
        zIndex='-1'
        src={`https://hnjiwdxlyyttjbocwpfw.supabase.co/storage/v1/object/public/blog/thumbnail${id}.png`}
      />
      {Object.entries(article.data.body).map((section, id) => {
        return <Section key={id} type={section[1].type} text={section[1].text} date={section[1].date} />;
      })}
      <SubscribeSection variant='flat' />
      <SuggestedArticles postId={id} />
    </Grid>
  );
};

export default ArticleLinks;
